import { ChartColumn, Cloud, Globe, Lock, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import SectionHead from "../SectionHead/SectionHead";
import "./Expertise.css";

// ícones na mesma ordem de home.expertise.items nos locales
const ICONS = [Users, Cloud, ChartColumn, Lock, Globe];

type Item = { title: string; text: string };

// Nossas expertises: o que os especialistas cobrem em cada camada. Ícones alternam rosa e navy.
export default function Expertise() {
  const { t } = useTranslation();
  const raw = t("home.expertise.items", { returnObjects: true });
  const items = Array.isArray(raw) ? (raw as Item[]) : [];

  return (
    <section className="cz-expertise" aria-labelledby="cz-expertise-title">
      <div className="cz-expertise__inner">
        <SectionHead id="cz-expertise-title" title={t("home.expertise.title")} text={t("home.expertise.text")} />
        <ul className="cz-expertise__grid">
          {items.map(({ title, text }, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <li key={title} className="cz-expert">
                <span className={`cz-expert__icon${i % 2 ? " cz-expert__icon--navy" : ""}`} aria-hidden="true">
                  <Icon size={19} strokeWidth={1.8} />
                </span>
                <h3 className="cz-expert__title">{title}</h3>
                <p className="cz-expert__text">{text}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
